import { AvailableVariableTypes } from 'components/domain/customData/useTemplateVariables';
import { SystemTemplates } from 'models/automation/SystemTemplates';
import { SystemTemplateRow } from './SystemTemplatesTab.types';

export const MESSAGES_SENT_TO_GUESTS_TEMPLATE_ROWS: SystemTemplateRow[] = [
  { key: SystemTemplates.PROPERTY_AVAILABLE },
  { key: SystemTemplates.PROPERTY_AVAILABLE_NO_PAYMENT },
  { key: SystemTemplates.PROPERTY_ON_HOLD },
  { key: SystemTemplates.PROPERTY_ON_HOLD_NO_PAYMENT },
  { key: SystemTemplates.PROPERTY_ON_HOLD_REMINDER, defaultStatus: true },
  {
    key: SystemTemplates.PROPERTY_ON_HOLD_REMINDER_NO_PAYMENT,
    defaultStatus: true,
  },
  { key: SystemTemplates.PROPERTY_UNAVAILABLE_OPTIONS },
  { key: SystemTemplates.PROPERTY_SUGGESTER },
  { key: SystemTemplates.SECURE_PAYMENT_VRBO, defaultStatus: true },
  { key: SystemTemplates.PROPERTY_UNAVAILABLE },
  { key: SystemTemplates.PROPERTY_MIN_STAY_INVALID },
  {
    key: SystemTemplates.AUTOMATED_REFUND_NOTICE_SUCCESSFUL_REFUND,
    defaultStatus: true,
  },
  { key: SystemTemplates.BALANCE_DUE, defaultStatus: true },
  { key: SystemTemplates.CAPTURE_REVIEW, defaultStatus: true },
  { key: SystemTemplates.CHARGE_USER },
  { key: SystemTemplates.UNCAPTURED_TRANSACTION_USER, defaultStatus: true },
  { key: SystemTemplates.BOOKING_ACCEPT, defaultStatus: true },
  { key: SystemTemplates.BOOKING_DECLINED, defaultStatus: true },
  { key: SystemTemplates.LEAD_CAPTURE_WIDGET, defaultStatus: true },
  { key: SystemTemplates.TRANSACTION_USER, defaultStatus: true },
  { key: SystemTemplates.TRANSACTION_USER_NO_PAYMENT, defaultStatus: true },
  { key: SystemTemplates.FAILED_TRANSACTION_USER, defaultStatus: true },
  { key: SystemTemplates.TRANSACTION_USER_FULL, defaultStatus: true },
  { key: SystemTemplates.LEAD_CONTRACT, defaultStatus: true },
  { key: SystemTemplates.PLANNED_TRIP, defaultStatus: true },
  { key: SystemTemplates.SERVICE_CONFIRMED_USER, defaultStatus: true },
  { key: SystemTemplates.PRE_ARRIVAL_REMINDER },
];

export const MESSAGES_SENT_TO_PROPERTY_MANAGERS_TEMPLATE_ROWS: SystemTemplateRow[] =
  [
    {
      key: SystemTemplates.ADJUSTMENT_BOOKING_CONFIRMED_AGENT,
      defaultStatus: true,
    },
    { key: SystemTemplates.PRE_CHECKIN_NOTIFICATION, defaultStatus: true },
    { key: SystemTemplates.TRANSACTION_AGENT, defaultStatus: true },
    { key: SystemTemplates.FAILED_TRANSACTION_AGENT, defaultStatus: true },
    { key: SystemTemplates.PAYMENT_FAILED, defaultStatus: true },
    { key: SystemTemplates.UNCAPTURED_TRANSACTION_AGENT, defaultStatus: true },
    { key: SystemTemplates.CAPTURE_REVIEW_PROCEED, defaultStatus: true },
    {
      key: SystemTemplates.AUTOMATED_REFUND_NOTICE_UPCOMING_REFUNDS,
      defaultStatus: true,
    },
    {
      key: SystemTemplates.AUTOMATED_REFUND_NOTICE_REFUND_FAILURE,
      defaultStatus: true,
    },
    {
      key: SystemTemplates.BULK_EDIT_PROPERTY_LOGICAL_FAILURE,
      defaultStatus: true,
    },
    { key: SystemTemplates.NOTIFY_GUEST_NEW_MESSAGE, defaultStatus: true },
    { key: SystemTemplates.NEW_BLOCKED_BY_OWNER, defaultStatus: true },
    { key: SystemTemplates.OWNER_BLOCKED_RECEIVED, defaultStatus: true },
    { key: SystemTemplates.OWNER_BLOCKED_UPDATED, defaultStatus: true },
    {
      key: SystemTemplates.ORDER_SERVICE_PURCHASE_NOTIFICATION,
      defaultStatus: true,
    },
    { key: SystemTemplates.JOB_SCHEDULED, defaultStatus: true },
    { key: SystemTemplates.JOB_DONE, defaultStatus: true },
    { key: SystemTemplates.JOB_DECLINED_AGENT, defaultStatus: true },
    {
      key: SystemTemplates.GUEST_PRE_ARRIVAL_FORM_SUBMITTED,
      defaultStatus: true,
    },
    {
      key: SystemTemplates.TRIGGER_FAILED,
      defaultStatus: false,
      readOnly: true,
    },
    {
      key: SystemTemplates.SECURITY_DEPOSIT_PRE_AUTHORIZATION_FAILED,
      defaultStatus: true,
    },
    {
      key: SystemTemplates.SCREEN_AND_PROTECT_STATUS_ALERT,
      defaultStatus: true,
    },
  ];

export const MESSAGES_SENT_TO_PROPERTY_OWNERS_TEMPLATE_ROWS: SystemTemplateRow[] =
  [
    { key: SystemTemplates.NOTITY_OWNER_NEW_STATEMENT },
    { key: SystemTemplates.NOTITY_OWNER_NEW_BOOKING },
    { key: SystemTemplates.INVITE_OWNER_TO_CLAIM_PROPERTY },
    { key: SystemTemplates.INVITE_UNACTIVE_OWNER_TO_CLAIM_PROPERTY },
  ];

export const MESSAGES_SENT_TO_SERVICE_PROVIDERS_TEMPLATE_ROWS: SystemTemplateRow[] =
  [
    { key: SystemTemplates.EMAIL_SERVICE_PROVIDER, defaultStatus: true },
    { key: SystemTemplates.EMAIL_SERVICE_PROVIDER_CANCEL, defaultStatus: true },
    { key: SystemTemplates.INVITE_SP_TO_CLAIM_AGENCY },
    { key: SystemTemplates.INVITE_UNACTIVE_SP_TO_CLAIM_AGENCY },
  ];

export const ALL_TEMPLATE_ROWS = [
  ...MESSAGES_SENT_TO_GUESTS_TEMPLATE_ROWS,
  ...MESSAGES_SENT_TO_PROPERTY_MANAGERS_TEMPLATE_ROWS,
  ...MESSAGES_SENT_TO_PROPERTY_OWNERS_TEMPLATE_ROWS,
  ...MESSAGES_SENT_TO_SERVICE_PROVIDERS_TEMPLATE_ROWS,
];

export const SYSTEM_TEMPLATE_VARIABLES: {
  [key in SystemTemplates]: AvailableVariableTypes[];
} = {
  [SystemTemplates.PROPERTY_AVAILABLE]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'message',
    'custom',
  ],
  [SystemTemplates.PROPERTY_AVAILABLE_NO_PAYMENT]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'message',
    'custom',
  ],
  [SystemTemplates.PROPERTY_ON_HOLD]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.PROPERTY_ON_HOLD_NO_PAYMENT]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.PROPERTY_ON_HOLD_REMINDER]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.PROPERTY_ON_HOLD_REMINDER_NO_PAYMENT]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.PROPERTY_UNAVAILABLE_OPTIONS]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.PROPERTY_UNAVAILABLE]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.PROPERTY_MIN_STAY_INVALID]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.INVITE_OWNER_TO_CLAIM_PROPERTY]: ['agency', 'property'],
  [SystemTemplates.INVITE_UNACTIVE_OWNER_TO_CLAIM_PROPERTY]: [],
  [SystemTemplates.INVITE_SP_TO_CLAIM_AGENCY]: [],
  [SystemTemplates.INVITE_UNACTIVE_SP_TO_CLAIM_AGENCY]: [],
  [SystemTemplates.BALANCE_DUE]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.BOOKING_ACCEPT]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.BOOKING_DECLINED]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.LEAD_CAPTURE_WIDGET]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.PRE_CHECKIN_NOTIFICATION]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.PAYMENT_FAILED]: [
    'transaction',
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.SECURE_PAYMENT_VRBO]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.BULK_EDIT_PROPERTY_LOGICAL_FAILURE]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.ORDER_SERVICE_PURCHASE_NOTIFICATION]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.AUTOMATED_REFUND_NOTICE_UPCOMING_REFUNDS]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.JOB_SCHEDULED]: [
    'job',
    'service',
    'agency',
    'property',
    'service_provider',
    'custom',
  ],
  [SystemTemplates.JOB_DONE]: [
    'job',
    'service',
    'agency',
    'property',
    'service_provider',
    'custom',
  ],
  [SystemTemplates.JOB_DECLINED_AGENT]: [
    'job',
    'service',
    'agency',
    'property',
    'service_provider',
    'custom',
  ],
  [SystemTemplates.GUEST_PRE_ARRIVAL_FORM_SUBMITTED]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.NEW_BLOCKED_BY_OWNER]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.OWNER_BLOCKED_UPDATED]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.AUTOMATED_REFUND_NOTICE_SUCCESSFUL_REFUND]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.AUTOMATED_REFUND_NOTICE_REFUND_FAILURE]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.OWNER_BLOCKED_RECEIVED]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.CAPTURE_REVIEW]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.PRE_ARRIVAL_REMINDER]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.NOTIFY_GUEST_NEW_MESSAGE]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.CAPTURE_REVIEW_PROCEED]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'review',
    'custom',
  ],
  [SystemTemplates.CHARGE_USER]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'transaction',
    'custom',
  ],
  [SystemTemplates.EMAIL_SERVICE_PROVIDER]: [
    'job',
    'service',
    'agency',
    'property',
    'custom',
    'service_provider',
  ],
  [SystemTemplates.EMAIL_SERVICE_PROVIDER_CANCEL]: [
    'job',
    'service',
    'agency',
    'property',
    'custom',
    'service_provider',
  ],
  [SystemTemplates.PROPERTY_SUGGESTER]: [
    'lead',
    'guest',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.ADJUSTMENT_BOOKING_CONFIRMED_AGENT]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'adjustment',
    'custom',
  ],
  [SystemTemplates.UNCAPTURED_TRANSACTION_USER]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'transaction',
    'custom',
  ],
  [SystemTemplates.UNCAPTURED_TRANSACTION_AGENT]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'transaction',
    'custom',
  ],
  [SystemTemplates.TRANSACTION_USER]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'transaction',
    'custom',
  ],
  [SystemTemplates.TRANSACTION_USER_NO_PAYMENT]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'transaction',
    'custom',
  ],
  [SystemTemplates.FAILED_TRANSACTION_USER]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'transaction',
    'custom',
  ],
  [SystemTemplates.TRANSACTION_AGENT]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'transaction',
    'custom',
  ],
  [SystemTemplates.FAILED_TRANSACTION_AGENT]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'transaction',
    'custom',
  ],
  [SystemTemplates.TRANSACTION_USER_FULL]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'transaction',
    'custom',
  ],
  [SystemTemplates.LEAD_CONTRACT]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'custom',
  ],
  [SystemTemplates.NOTITY_OWNER_NEW_STATEMENT]: ['statement', 'user'],
  [SystemTemplates.NOTITY_OWNER_NEW_BOOKING]: [
    'lead',
    'guest',
    'property',
    'agency',
    'order',
    'custom',
  ],
  [SystemTemplates.PLANNED_TRIP]: [
    'lead',
    'guest',
    'property',
    'agency',
    'custom',
  ],
  [SystemTemplates.SERVICE_CONFIRMED_USER]: [
    'lead',
    'service',
    'agency',
    'service_provider',
  ],
  [SystemTemplates.TRIGGER_FAILED]: [
    'lead',
    'guest',
    'order',
    'agency',
    'property',
    'transaction',
    'custom',
  ],
  [SystemTemplates.SECURITY_DEPOSIT_PRE_AUTHORIZATION_FAILED]: [
    'transaction',
    'lead',
    'guest',
    'order',
    'agency',
    'property',
  ],
  [SystemTemplates.SCREEN_AND_PROTECT_STATUS_ALERT]: [
    'lead',
    'guest',
    'agency',
    'property',
    'screening',
    'custom',
  ],
};
